export default {
  bookingview: {
    name: 'การจอง',
    fields: {
      book_id: 'หมายเลขนัดหมาย',
      title: 'รหัส, ชื่อ, นามสกุล, เบอร์ หรือ อีเมล',
      name: 'ชื่อ-นามสกุล',
      first_name: 'ชื่อ',
      last_name: 'นามสกุล',
      tel: 'เบอร์โทร',
      email: 'อีเมล',
      license_plate: 'ทะเบียนรถ',
      province: 'จังหวัด',
      code: 'รหัส',
      branch_code: 'สาขา',
      fname_lname: 'ชื่อ / นามสกุล',
      status: {
        label: 'สถานะ',
        choices: {
          confirm: 'ยืนยันนัดหมาย',
          cancel: 'ยกเลิก',
          pending: 'รอดำเนินการ',
          reserve: 'จอง',
          temporary_request: 'ขอคิวสำรอง',
          complete: 'เสร็จสิ้น',
        },
      },
      booking_date: 'วันที่จอง',
      create_at: 'วัน-เวลาที่สร้าง',
      start_date: 'วันที่เริ่มต้น',
      end_date: 'วันที่สิ้นสุด',
      more_detail: 'รายละเอียดเพิ่มเติม',
      is_accept_terms_conditions: 'ยอมรับเงื่อนไข',
      is_active: 'ใช้งาน',
      booking_slot: 'ช่อง',
      start_time: 'เวลาเริ่มต้น',
      end_time: 'เวลาสิ้นสุด',
      car_brand: 'แบรนด์รถยนต์',
      car_model: 'รุ่นรถยนต์',
      service: 'บริการ',
      cancel_reason: 'เหตุผลในการยกเลิก',
      other_reason: 'ระบุเหตุผล',
      show: { title: 'รายละเอียดการจอง' },
    },
  },
}
